module.exports = __webpack_public_path__ + "static/TIC30_1122-a315a797310decfbf5bfd4464e54a6e7.png";